module.exports = __webpack_public_path__ + "static/media/bg-mobile.475a65aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bg-mobile.png
// module id = 295
// module chunks = 0